import { QueryClient } from '@tanstack/react-query';

/**
 * Shared TanStack QueryClient singleton.
 *
 * Defaults worth defending:
 *   - `retry: 1` — one retry for transient 5xx or network blips. Anything
 *     higher becomes a latency amplifier when the API is actually down.
 *   - `refetchOnWindowFocus: false` — the CDR flows are not real-time. The
 *     "oh you came back to the tab, let me spam the server" default is a
 *     terrible fit for an upload/processing workflow where refetches can
 *     overwrite optimistic UI state.
 *   - `staleTime: 30s` — cut down on redundant refetches for runs/customers
 *     that do not change on a per-interaction basis.
 *
 * `main.tsx` owns the lifetime of this client; T-050 just exposes the
 * factory so test harnesses can mint a fresh client per test.
 */
export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 30 * 1000,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
